<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="where" label-width="77px" @keyup.enter.native="reload" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="用户订单">
              <el-input clearable v-model="where.merchantOrderNo" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="系统订单">
              <el-input clearable v-model="where.orderNo" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="交易类型">
              <el-select clearable v-model="where.channel_id" placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in channelList" :key="item.channel_id" :value="item.channel_id"
                  :label="item.channel_name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="提现姓名">
              <el-input clearable v-model="where.inPayerName" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="交易状态">
              <el-select clearable v-model="where.order_status" placeholder="请选择" style="width: 100%;">
                <el-option label="全部" value="all"> </el-option>
                <el-option label="未知" value="0"> </el-option>
                <el-option label="成功" value="1"> </el-option>
                <el-option label="失败" value="2"> </el-option>
                <el-option label="撤销" value="3"> </el-option>
                <el-option label="异常" value="4"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="10" :md="12">
            <el-form-item label="选择时间">
              <el-date-picker v-model="where.time" type="daterange" range-separator="～" start-placeholder="开始日期"
                value-format="yyyy-MM-dd" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div>
              <el-button type="primary" icon="el-icon-search" @click="reload">查询
              </el-button>
              <el-button @click="reset">重置</el-button>
              <el-button type="danger" icon="el-icon-document" size="small" @click="onExportClick">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-pro-table ref="table" :where="where" :datasource="url" :columns="columns" :selection.sync="selection"
        height="calc(100vh - 315px)">
        <!-- 状态列 -->
        <template slot="order_status" slot-scope="{ row }">
          <el-tag v-if="row.order_status === 0" type="warning" size="small"><strong>未知</strong></el-tag>
          <el-tag v-if="row.order_status === 1" type="success" size="small"><strong>成功</strong></el-tag>
          <el-tag v-if="row.order_status === 2" type="danger" size="small"><strong>失败</strong></el-tag>
          <el-tag v-if="row.order_status === 3" type="danger" size="small"><strong>撤销</strong></el-tag>
          <el-tag v-if="row.order_status === 4" type="danger" size="small"><strong>异常</strong></el-tag>
        </template>
      </ele-pro-table>
    </el-card>

    <export-progress-dialog ref="exportDialog" biz="outorder" title="导出代付订单" />
  </div>
</template>

<script>
import ExportProgressDialog from '@/components/ExportProgressDialog.vue';

export default {
  name: 'Outorder',
  components: { ExportProgressDialog },
  data() {
    return {
      // 表格数据接口
      url: "/Outorder/getListIn",

      // 表格列配置
      columns: [
        {
          prop: "id",
          label: "ID",
          width: 60,
          align: "center",
          showOverflowTooltip: true,
          fixed: "left"
        },
        {
          prop: "merchantOrderNo",
          label: "用户订单",
          showOverflowTooltip: true,
          minWidth: 200,
          align: "center"
        },
        {
          prop: "orderNo",
          label: "系统订单",
          showOverflowTooltip: true,
          minWidth: 200,
          align: "center"
        },
        {
          prop: "channel_name",
          label: "交易类型",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center"
        },
        {
          prop: "paymentAmount",
          label: "交易金额",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center"
        },
        {
          prop: "paymentCurrency",
          label: "币种",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center"
        },
        {
          prop: "mch_fees",
          label: "交易费率",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center"
        },
        {
          prop: "mch_rate",
          label: "手续费",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center"
        },
        {
          prop: "payerName",
          label: "提现名称",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center"
        },
        {
          prop: "payerBankName",
          label: "提现银行",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center"
        },
        {
          prop: "payerBankBranchName",
          label: "银行分行",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center"
        },
        {
          prop: "payerAccount",
          label: "银行账号",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center"
        },

        {
          prop: "create_time",
          label: "交易时间",
          showOverflowTooltip: true,
          minWidth: 200,
          align: "center",
          formatter: (row, column, cellValue) => {
            return this.$util.toDateString(cellValue);
          }
        },
        {
          prop: "order_status",
          label: "交易状态",
          showOverflowTooltip: true,
          slot: "order_status",
          minWidth: 100,
          align: "center",
          fixed: "right"
        },
        {
          prop: "update_time",
          label: "完成时间",
          showOverflowTooltip: true,
          minWidth: 200,
          align: "center",
          formatter: (row, column, cellValue) => {
            return cellValue ? this.$util.toDateString(cellValue) : "--";
          }
        }
      ],
      // 表格搜索条件
      where: {},
      // 表格选中数据
      selection: [],
      channelList: [],
    };
  },
  mounted() {
    this.getChannelList();
  },
  methods: {
    /* 刷新表格 */
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    /* 重置搜索 */
    reset() {
      this.where = {};
      this.reload();
    },
    /* 查询财务列表 */
    getChannelList() {
      this.$http
        .post("/Inorder/getchannelList", {
          type: 2
        })
        .then(res => {
          if (res.data.code === 0) {
            this.channelList = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },

    onExportClick() {
      this.$refs.exportDialog.start({ ...this.where });
    }
  }
};
</script>

<style>
.el-form-item label {
  font-weight: bold;
  font-size: 16px;
}
</style>
